import { MAP_LOAD, MAP_LOAD_LIST } from './map.actions';
import { IMapState, MapActions } from './map.types';
import produce from 'immer';
import { MapDto, MapDetailDto } from '../../models/models';

const mapInitialState: IMapState = {
	loadedMaps: {},
	maps: []
};

export function mapReducer(
	state: IMapState = mapInitialState,
	action: MapActions
): IMapState {
	switch (action.type) {
		case MAP_LOAD: {
			return replaceMap(state, action.payload as MapDetailDto);
		}
		case MAP_LOAD_LIST: {
			return loadMapList(state, action.payload as MapDto[]);
		}
		default: {
			return state;
		}
	}
}

function replaceMap(currentState: IMapState, map: MapDetailDto): IMapState {
	return produce(currentState, (draftState: IMapState) => {
		draftState.loadedMaps[map.id] = map;
	});
}

function loadMapList(currentState: IMapState, maps: MapDto[]): IMapState {
	return produce(currentState, (draftState: IMapState) => {
		draftState.maps = maps;
	});
}
